import { ActivatedRoute, Router } from '@angular/router';
import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';

// import { GoogleLoginProvider } from 'angularx-social-login';
// import { SocialAuthService } from "angularx-social-login";
import { HttpClient } from '@angular/common/http';
import { MainService } from '../main.service';
// import { NgxSpinnerService } from 'ngx-spinner';

// import { SocialAuthService } from 'angularx-social-login';
import { SocialLoginModule } from '@abacritt/angularx-social-login';
import Swal from 'sweetalert2';
import {
  SocialAuthService, FacebookLoginProvider,
  GoogleLoginProvider
} from '@abacritt/angularx-social-login';
enum CheckBoxType {
  APPLY_FOR_JOB,
  MODIFY_A_JOB,
  NONE,

}
declare var $: any;
declare var google: any;

import jwt_decode from 'jwt-decode';
import { SecurityService } from '../security.service';



@Component({
  selector: 'lib-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {

  constructor(
    private mainService: MainService,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    public OAuth: SocialAuthService,
    public zone: NgZone,
    public securitySvc:SecurityService
    ,
  ) {


    // this.mainService.getRetuenUrlWithAcctID('/edit')
    // this.mainService.customObservable.subscribe((res) => {
    //   this.AuthorizationApplicable(res)
    // });
  }

  check_box_type = CheckBoxType;
  isChecked: CheckBoxType = 0;
  accountlist: Array<any> = [];
  b_acct_id: any;
  legalentityrecord: any;
  select_acct: boolean = false;
  openOTP: boolean = false;
  userdetails = {
    phone_no: undefined,
    password: '',
    email: undefined,
    verify_method: '',
  };
  acctIdforNoAccount = 'noAccount'
  jwtToken: any;
  parms_acct_id: any;
  passnum: number = 11
  urlParams: any;
  assigned_user_modules: [] | any;
  login: any = {


  };
  num = 12
  error_flag1: any;
  selectedaccount: any;

  party_name: any;
  assigned_User_Roles: [] | any;
  allComponentCode: Array<any> = [];
  AllUserRole: [] | any;
  product_cd: [] | any;
  legal_mobile_no: any;
  audit_info_obj = {
    user_id: '',
    login_time: null,
    login_ip: null,
    login_browser: null,
    latitude: null,
    longitude: null,
    active_from_time: null,
    logout_time: null,
    login_type: 'ONLOAD',
    status: 'NA',
    login_id: undefined,
    password: null,
    message: 'Login Auth...',
  };
  otpuser = {
    mobile_number: '',
    otp_no: '',
  };
  otp_flag = false;
  ipAddress: any;
  browser: any;
  date: any;
  lat: any;
  lng: any;
  zoom: any;
  session_id: any;
  loginpass_flag = false;
  verfiy_token_obj = { authtoken: '' };
  solnHostUrl: any;
  pubHostUrl: any;
  hostWithReturnUrls = [];
  currentOrigin: any;
  urlPassAcctID: any;
  urlPassReturnfpath: any;
  fpath: any;
  user: any;
  loggedIn: boolean;


  async ngOnInit() {
    sessionStorage.removeItem('erpUser');
    sessionStorage.removeItem('svm_jwt');

    this.currentOrigin = location.protocol + '//' + location.hostname;
    this.loginpass_flag = this.mainService.loginWithPassword;
    // this.hostWithReturnUrls = this.mainService.hostWithReturnUrl;

    console.log(this.mainService.hostWithReturnUrl)
    this.getHostFpath();
    this.urlPassAcctID = this.mainService.urlPassAcctID;
    this.urlPassReturnfpath = this.mainService.urlPassReturnfpath;

    await this.getAuthConfig()
    const togglePassword = document
      .querySelector('#togglePassword');
    const password = document.querySelector('#password');
    togglePassword.addEventListener('click', () => {
      // Toggle the type attribute using
      // getAttribure() method
      const type = password
        .getAttribute('type') === 'password' ?
        'text' : 'password';
      password.setAttribute('type', type);
      // Toggle the eye and bi-eye icon
      //this.classList.toggle('bi-eye');
    });


    // this.googleAuthSDK();
    //   google.accounts.id.initialize({
    //     client_id: '317079145994-njhoq3f8dgj2kjj5jjr1m4ksts5if9g8.apps.googleusercontent.com',
    //     callback: this.handleCredentialResponse.bind(this),
    //     auto_select:false,
    //     cancel_on_tap_outside:true
    //   });
    //   google.accounts.id.renderButton(
    //     document.getElementById("signin_button"),
    //       { type: "icon",theme: "filled_blue", size: "large" }   // customization attributes
    //   );
    //   google.accounts.id.prompt();

  }
  //emailFlag=false;
  otpFlag = false
  goaFlag = false
  passflag = false;
  emailFlag = false;
  phoneFlag = false;
  async getAuthConfig() {
    console.log(this.mainService.auth_validation);
    this.otpFlag = false;
    this.goaFlag = false
    this.passflag = false;
    this.emailFlag = false;
    this.phoneFlag = false

    if (this.mainService.auth_validation['E-KEY']) {
      this.passflag = true;
      this.emailFlag = true
      this.isChecked = 1;
      // this.emailRegFlag=true;
    }
    if (this.mainService.auth_validation['GOA']) {

      this.goaFlag = true;
      await this.getData()
    }
    if (this.mainService.auth_validation['P-KEY']) {
      this.passflag = true;
      this.phoneFlag = true;
      this.isChecked = 0;
    }
    if (this.mainService.auth_validation['OTP']) {
      this.otpFlag = true;
      this.loginType="otp"
    }
    if ((this.mainService.auth_validation['E-KEY'] || this.mainService.auth_validation['P-KEY']) && (this.mainService.auth_validation['OTP'])) {
      this.num = 12
      this.loginType="password"
    }
    if (this.mainService.auth_validation['E-KEY'] && this.mainService.auth_validation['P-KEY']) {
      this.passnum = 5
    }
    // console.log(this.emailFlag,this.phoneFlag);


  }
  async getData() {
    {
      let googleScript = document.createElement('script');
      googleScript.src = 'https://accounts.google.com/gsi/client';
      document.head.appendChild(googleScript);
      setTimeout(async () => {
        google.accounts.id.initialize({
          client_id: "317079145994-njhoq3f8dgj2kjj5jjr1m4ksts5if9g8.apps.googleusercontent.com",
          callback: await this.handleCredentialResponse.bind(this),
        });
        google.accounts.id.renderButton(
          document.getElementById("signin_button"),
          { type: "icon", theme: "filled_blue", size: "large" }

        );

      }, 100);

    }
  }

  cancel() {
    this.router.navigate([this.fpath])

  }



  async handleCredentialResponse(response: any) {
    console.log(response, 'handleCredentialResponse');
    // console.log(response.credential);


    var responsePayload: any = jwt_decode(response.credential);
    console.log(responsePayload);


    console.log("ID: " + responsePayload.sub);
    console.log('Full Name: ' + responsePayload.name);
    console.log('Given Name: ' + responsePayload.given_name);
    console.log('Family Name: ' + responsePayload.family_name);
    console.log("Image URL: " + responsePayload.picture);
    console.log("Email: " + responsePayload.email);
    await this.socialSignIn(responsePayload.email)
    // this.regularFunction()







  }


  regularFunction() {
    console.log('hey');



  }


  getHostFpath() {
    console.log(this.hostWithReturnUrls)
    for (const hostapp of this.mainService.hostWithReturnUrl) {
      if (hostapp['name'] == 'solnAdmin') {
        this.solnHostUrl = hostapp['host'];
      }
      if (hostapp['name'] == 'erppublic') {
        this.pubHostUrl = hostapp['host'];
      }
      if (this.currentOrigin == hostapp['host']) {
        this.fpath = hostapp['fpath'];
      }
    }
  }

  // user ip address
  IPAddressofUser() {
    this.http
      .get('https://api.ipify.org/?format=json')
      .subscribe((res: any) => {
        this.ipAddress = res.ip;
        this.audit_info_obj['login_ip'] = this.ipAddress;
      });
  }

  //list of browser name
  public UserBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase();
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }

  // user loaction
  geoLocation() {
    var pos;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(async (position) => {
        this.lat = position.coords.latitude;
        this.lng = position.coords.longitude;
        this.zoom = 16;
        this.audit_info_obj['latitude'] = this.lat;
        this.audit_info_obj['longitude'] = this.lng;
      });
    } else {
      alert('Browser Does`t Supported');
    }
  }

  //get login time
  async ngAfterContentInit() {
    setTimeout(async () => {
      await this.geoLocation();
    }, 500);
    setTimeout(async () => {
      await this.IPAddressofUser();
    }, 500);

    //browser set

    this.browser = await this.UserBrowserName();
    this.audit_info_obj['login_browser'] = this.browser;

    //active time set
    var current = new Date();
    this.date = current.toLocaleString();
    this.audit_info_obj['active_from_time'] = this.date;
    setTimeout(async () => {
      await this.audit_insert(this.audit_info_obj);
    }, 3000);
  }

  selectCheckBox(targetType: CheckBoxType) {
    // If the checkbox was already checked, clear the currentlyChecked variable
    if (this.isChecked === targetType) {
      this.isChecked = CheckBoxType.NONE;
      return;
    }
    this.isChecked = targetType;
  }

  //Details of employee
  async getCurrentLegalEntity() {
    var party_details = {
      b_acct_id: '',
      phone_no: undefined,
      contact_email: undefined,
    };
    party_details['b_acct_id'] = this.parms_acct_id['acct_id'];
    party_details['phone_no'] = this.userdetails['phone_no'];
    party_details['contact_email'] = this.userdetails['email'];
    var resp = await this.mainService.getCurrentLegalEntity(
      JSON.stringify(party_details)
    );
    if (resp['error'] == false) {
      this.legalentityrecord = resp.data;
    } else {
    }
  }


  setpartydtls: any = {}

  //Login to Password Process

  async submit() {
    // console.log(this.urlPassAcctID);
    this.setpartydtls = {}

    //check login email/phone

    if (this.isChecked == 0 || this.isChecked == 1) {
      if (this.userdetails['password'] == '') {
        Swal.fire('Error', 'Please enter Password', 'error');
        return;
      }
      var mobile_valid = this.mainService.validatePhoneNumber(
        this.userdetails['phone_no']
      );
      var email_valid = this.mainService.validateEmail(
        this.userdetails['email']
      );

      this.audit_info_obj['login_type'] = 'PASSWORD';
      this.audit_info_obj['login_id'] = (this.isChecked == 0) ? (this.userdetails['phone_no']) : (this.userdetails['email'])
      // this.audit_info_obj['login_id'] = this.userdetails['phone_no'];
      this.audit_info_obj['password'] = null;

      //check mobile login
      if (mobile_valid == true && this.isChecked == 0) {
        this.userdetails['email'] = undefined;
        var userloginmob = {
          ident_to_verify: undefined,
          ident_verify_method: '',
          ident_verify_secret: '',
        };
        userloginmob['ident_to_verify'] = this.userdetails['phone_no'];
        userloginmob['ident_verify_method'] = 'P-KEY';
        userloginmob['ident_verify_secret'] = this.userdetails['password'];


        var resp = await this.mainService.loginERP(userloginmob);

        if (resp['error'] == false && resp['data'].length > 0) {
          this.setpartydtls = resp['data'][0]
          this.finalLoginforNoAccount('P-KEY')

          //let objsend={'sol_cd':'erp','acct_id':91}
          //this.mainService.callComponentMethod(objsend)

        } else if (resp['data'].length == 0) {
          this.audit_info_obj['status'] = 'FAIL';
          this.audit_info_obj['user_id'] = '';
          this.audit_info_obj['message'] = 'failed to login account';
          await this.audit_insert(this.audit_info_obj);
          Swal.fire('Error', 'Failed', 'error');
        } else {
          this.audit_info_obj['status'] = 'FAIL';
          this.audit_info_obj['user_id'] = '';
          this.audit_info_obj['message'] = resp['data'];
          Swal.fire('Error...', resp['data'], 'error');
          await this.audit_insert(this.audit_info_obj);
        }
      }
      //check email login
      else if (email_valid == true && this.isChecked == 1) {
        this.userdetails['phone_no'] = undefined;
        var userloginemail = {
          ident_to_verify: undefined,
          ident_verify_method: '',
          ident_verify_secret: '',
        };
        userloginemail['ident_to_verify'] = this.userdetails['email'];
        userloginemail['ident_verify_method'] = 'E-KEY';
        userloginemail['ident_verify_secret'] = this.userdetails['password'];


        var resp = await this.mainService.loginERP(userloginemail);
        if (resp['error'] == false && resp['data'].length > 0) {
          this.setpartydtls = resp['data'][0]

          this.finalLoginforNoAccount('E-KEY')

        } else if (resp['data'].length == 0) {
          this.audit_info_obj['status'] = 'FAIL';
          this.audit_info_obj['user_id'] = '';
          this.audit_info_obj['message'] = 'failed to login account';

          await this.audit_insert(this.audit_info_obj);
          Swal.fire('Oops...', 'Failed to login account', 'error');
        } else {
          this.audit_info_obj['status'] = 'FAIL';
          this.audit_info_obj['user_id'] = '';
          this.audit_info_obj['message'] = resp['data'];

          await this.audit_insert(this.audit_info_obj);
          Swal.fire('Error...', resp['data'], 'error');
        }
      } else {
        Swal.fire('Error...', 'Invalid Credentials', 'error');
      }
    } else {
      Swal.fire('Warning', ' Please Select An Option For Login', 'warning');
    }
  }





  //employee related role data



  //user system details insert
  async audit_insert(audit_info_obj: any) {
    var resp = await this.mainService.createloginInfo(audit_info_obj);
    console.log(resp);
    if (resp['error'] == false) {
      let count = resp['count']?.['login_count']
      console.log(count);

      if (count == 1 && (this.login_type == 'E-KEY' || this.login_type == 'P-KEY')) {
        //  $('').modal.show()
        $('#updatePass').modal('show');
        return 0;

      }
      else {
        return 1;
      }

    }
    else {
      return 1;
    }

  }
  close() {
    $('#updatePass').modal('hide');

  }
  pass = {}
  async updatePassword() {
    console.log(this.pass);
    if (this.pass['ident_verify_secret'] !== this.pass['c_ident_verify_secret']) {
      Swal.fire('Oops', 'Password does not match', 'error');
      return
    }
    this.pass['user_id'] = this.setpartydtls['le_id'];

    console.log(this.pass)
    // this.spinner.show()
    var resp = await this.mainService.changeUserPassword(this.pass);
    console.log(resp);
    if (resp['error'] == false) {
      Swal.fire('success', resp['data'], 'success');
      $('#updatePass').modal('hide');
      await this.routeToApp()
    } else {
      // this.spinner.hide()

      Swal.fire('Oops', resp['data'], 'error');
    }

  }
  showhidepass() {

  }
  show() {
    $('#updatePass').modal('show');
  }

  //final submit


  ////final Login for no Account
  login_type: any
  async finalLoginforNoAccount(login_type) {
    this.login_type = login_type
    this.login['party_name'] = this.setpartydtls['legal_name'];
    this.login['party_dob'] = this.setpartydtls['party_dob'];
    this.login['party_type'] = this.setpartydtls['party_type'];
    this.login['contact_phone'] = this.setpartydtls['phone_no'];
    this.login['user_id'] = this.setpartydtls['le_id'];
    this.login['identity_id'] = this.setpartydtls['identity_id']
    this.login['le_id'] = this.setpartydtls['le_id'];
    this.login['contact_email'] = this.setpartydtls['contact_email'];

    this.audit_info_obj['status'] = 'PASS';
    this.audit_info_obj['user_id'] =
      'User ID:' +
      this.setpartydtls['le_id']

    this.audit_info_obj['message'] = 'Logged In Successfully!';

    //await this.audit_insert(this.audit_info_obj);
    let resploginfo = await this.audit_insert(this.audit_info_obj);
    if (resploginfo) {
      
      await this.routeToApp()
    }





  }
  async routeToApp() {
  //  Swal.fire('Success', 'Logged In Successfully! ', 'success');

    /// jwt token generated
    const { ident_verify_secret, ...filterdata } = this.login;
    var resp = await this.mainService.generateTokens(filterdata);
    this.jwtToken = resp['jwt'];


    //storing svm_jwt and erpUser into session storage
    sessionStorage.setItem('erpUser', JSON.stringify(filterdata));
    sessionStorage.setItem('svm_jwt', JSON.stringify(this.jwtToken));
    await this.securitySvc.getAllAccounts()
    // if (this.urlPassReturnfpath == undefined || this.urlPassReturnfpath == null || this.urlPassReturnfpath == "") {
    //   console.log('came to this')
    //   console.log(this.fpath);


    //   this.zone.run(() => {
    //     this.router.navigate(['./' + this.fpath]);
    //   });

    // } else {
    //   this.zone.run(() => {
    //     this.router.navigate(['./' + this.urlPassReturnfpath]);
    //   });
    // }

  }

  //assigned component of employee


  //party name


  //Login to otp process
  async sendOtp() {
    var otpuserobj = { ident_to_verify: '', ident_verify_method: '' };

    if (this.otpuser['mobile_number'] == '') {
      Swal.fire('Error', 'Please Enter Mobile Number', 'error');
      return;
    }
    // this.userdetails['phone_no'] = this.otpuser['mobile_number'];
    otpuserobj['ident_to_verify'] = this.otpuser['mobile_number'];
    otpuserobj['ident_verify_method'] = 'OTP';


    var resp = await this.mainService.loginERP(otpuserobj);
    if (resp['error'] == false) {
      if (resp['data'].length == 0) {
        Swal.fire('Oops', 'Your are not registered!', 'error');
        this.error_flag1 = true;
        return;
      } else {
        this.error_flag1 = false;
      }
    } else {
      Swal.fire('Error', 'Not Registered Or Login Failed!', 'error');
      this.error_flag1 = true;
      return;
    }
    //send otp
    this.legal_mobile_no = this.otpuser['mobile_number'];
    var resp = await this.mainService.sendMsg(this.legal_mobile_no);
    if (resp['Status'] == 'Success') {
      this.openOTP = true;
      this.session_id = resp['Details'];
      Swal.fire('Success', 'OTP Generated Successfully', 'success');
    }
  }
  // submit otp
  async LoginWithOtp() {
    //check usermobile number to  registered mobile_no
    this.userdetails['email'] = undefined;
    this.userdetails['phone_no'] = undefined;
    if (this.otpuser['mobile_number'] == this.legal_mobile_no) {
      this.audit_info_obj['login_type'] = 'OTP';
      this.audit_info_obj['login_id'] = this.legal_mobile_no;
      this.audit_info_obj['password'] = null;
      //verfiy otp
      if (
        await this.mainService.verifyMsg(
          this.otpuser['otp_no'],
          this.session_id
        )
      ) {
        var otpuserdata = { ident_to_verify: '', ident_verify_method: '' };
        otpuserdata['ident_to_verify'] = this.otpuser['mobile_number'];
        otpuserdata['ident_verify_method'] = 'OTP';


        var resp = await this.mainService.loginERP(otpuserdata);

        if (resp['error'] == false && resp['data'].length > 0) {
          this.setpartydtls = resp['data'][0]
          this.finalLoginforNoAccount('OTP')

        }

        else if (resp['data'].length == 0) {
          this.audit_info_obj['status'] = 'FAIL';
          this.audit_info_obj['user_id'] = '';
          this.audit_info_obj['message'] = 'Failed to Login!';

          await this.audit_insert(this.audit_info_obj);
          Swal.fire('Oops', 'User Not Registered!', 'error');
        } else if (resp['error'] == true) {
          this.audit_info_obj['status'] = 'FAIL';
          this.audit_info_obj['user_id'] = '';
          this.audit_info_obj['message'] = 'Login Failed due to api error true';

          await this.audit_insert(this.audit_info_obj);
          Swal.fire('Error...', 'Login Failed', 'error');
        }
      }
      else {
        this.audit_info_obj['status'] = 'FAIL';
        this.audit_info_obj['user_id'] = '';
        this.audit_info_obj['message'] = 'OTP Not Match!';

        await this.audit_insert(this.audit_info_obj);

        Swal.fire('Error...', 'OTP Not Match!', 'error');
      }
    } else {
      Swal.fire('Error...', 'Invalid Credentials', 'error');
    }
  }

  //Login to Social Login
  async socialSignIn(mail) {
    var obj = new Object();
    obj['ident_to_verify'] = mail;
    obj['ident_verify_method'] = 'GOA';

    this.audit_info_obj['login_id'] = mail;
    this.audit_info_obj['password'] = null;
    this.audit_info_obj['login_type'] = 'GOA';


    var resp = await this.mainService.loginERP(obj);
    if (resp['error'] == false && resp['data'].length > 0) {
      this.setpartydtls = resp['data'][0]

      await this.finalLoginforNoAccount('GOA')

    } else if (resp['data'].length == 0) {
      this.audit_info_obj['status'] = 'FAIL';
      this.audit_info_obj['user_id'] = '';
      this.audit_info_obj['message'] = 'failed to login account';

      await this.audit_insert(this.audit_info_obj);
      Swal.fire('Oops...', 'Failed to login account', 'error');
    } else {
      this.audit_info_obj['status'] = 'FAIL';
      this.audit_info_obj['user_id'] = '';
      this.audit_info_obj['message'] = resp['data'];

      await this.audit_insert(this.audit_info_obj);
      Swal.fire('Error...', resp['data'], 'error');
    }



  };
  async goback() {
    this.select_acct = false;
  }
  getResponse() {
    console.log('jii');

  }

  gotosignUp(){
    this.router.navigate(['/register'])
  }
  loginType="password"





}

